export default __webpack_public_path__ + "static/media/c001-ngo-1.2a9de283.jpg";